module.exports = __webpack_public_path__ + "img/false.e57e703f.png";